import React from 'react';
import './Services.css';

const Services = () => {
    const services = [
        {
            icon: '⚖️',
            title: 'MAP Compliance',
            description:
                'Automated pricing enforcement with zero tolerance for violations.',
            features: [
                'Real-time Price Monitoring',
                'Automated Violation Detection',
                'Zero Tolerance Policy',
                'Instant Corrective Actions',
            ],
        },
        {
            icon: '✅',
            title: 'Authorized Seller',
            description:
                'Verified documentation with full brand authorization.',
            features: [
                'Complete Documentation',
                'Brand Authorization',
                'Verification Process',
                'Compliance Certification',
            ],
        },
        {
            icon: '⚡',
            title: 'Fast Operations',
            description: 'Same-day processing with premium fulfillment.',
            features: [
                'Same-Day Processing',
                'Premium Fulfillment',
                'Fast Turnaround',
                'Efficient Operations',
            ],
        },
        {
            icon: '📊',
            title: 'Data-Driven Advertising',
            description:
                'We run effective ad campaigns on Amazon, Meta, and Google to scale your business.',
            features: [
                'Amazon Advertising',
                'Meta Campaigns',
                'Google Ads',
                'Performance Analytics',
            ],
        },
        {
            icon: '🔍',
            title: 'Competitive Insights',
            description:
                'Analyze your market with tools like Keepa and Helium10.',
            features: [
                'Market Analysis',
                'Competitor Tracking',
                'Price Monitoring',
                'Trend Analysis',
            ],
        },
        {
            icon: '🛒',
            title: 'Multi-Channel Sales',
            description:
                'Reach more customers on Amazon, Walmart, Shopify, and other top platforms.',
            features: [
                'Amazon Integration',
                'Walmart Marketplace',
                'Shopify Store',
                'Multi-Platform Sales',
            ],
        },
        {
            icon: '📦',
            title: 'Inventory Management',
            description:
                'We handle storage, prep, and shipments from our US-based warehouse.',
            features: [
                'US-Based Warehouse',
                'Storage Solutions',
                'Product Preparation',
                'Shipment Management',
            ],
        },
        {
            icon: '💰',
            title: 'Ad Investment',
            description:
                'We allocate advertising budgets on your behalf across Amazon, Meta, and Google.',
            features: [
                'Budget Allocation',
                'Amazon Ads',
                'Meta Advertising',
                'Google Campaigns',
            ],
        },
        {
            icon: '🎨',
            title: 'A+ Content & Optimization',
            description:
                'We enhance listings with high-converting visuals and backend SEO.',
            features: [
                'A+ Content Creation',
                'Visual Enhancement',
                'Backend SEO',
                'Conversion Optimization',
            ],
        },
    ];

    return (
        <section className="services section">
            <div className="container">
                <div className="section-header">
                    <p className="section-subtitle">
                        Avenis is your new avenue to smarter selling. Inventory,
                        compliance, and marketing handled. You focus on your
                        product; we scale your sales. Authorized retail partner
                        delivering MAP-compliant, brand-safe e-commerce
                        solutions with complete transparency and
                        enterprise-grade protection.
                    </p>
                </div>

                <div className="services-grid">
                    {services.map((service, index) => (
                        <div key={index} className="service-card">
                            <div className="service-card-bg"></div>
                            <div
                                className={`service-icon service-icon-${
                                    index + 1
                                }`}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    {index === 0 && (
                                        <>
                                            <path d="M9 11H5a2 2 0 0 0-2 2v3c0 1.1.9 2 2 2h4"></path>
                                            <path d="M15 11h4a2 2 0 0 1 2 2v3c0 1.1-.9 2-2 2h-4"></path>
                                            <path d="M9 7h6v4H9z"></path>
                                            <path d="M9 3h6v4H9z"></path>
                                        </>
                                    )}
                                    {index === 1 && (
                                        <>
                                            <path d="M9 12l2 2 4-4"></path>
                                            <path d="M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9 9 4.03 9 9z"></path>
                                        </>
                                    )}
                                    {index === 2 && (
                                        <>
                                            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path>
                                        </>
                                    )}
                                    {index === 3 && (
                                        <>
                                            <path d="M3 3v18h18"></path>
                                            <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                                        </>
                                    )}
                                    {index === 4 && (
                                        <>
                                            <circle
                                                cx="11"
                                                cy="11"
                                                r="8"
                                            ></circle>
                                            <path d="M21 21l-4.35-4.35"></path>
                                        </>
                                    )}
                                    {index === 5 && (
                                        <>
                                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                                            <polyline points="9,22 9,12 15,12 15,22"></polyline>
                                        </>
                                    )}
                                    {index === 6 && (
                                        <>
                                            <path d="M3 3v18h18"></path>
                                            <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                                        </>
                                    )}
                                    {index === 7 && (
                                        <>
                                            <path d="M3 3v18h18"></path>
                                            <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3"></path>
                                        </>
                                    )}
                                    {index === 8 && (
                                        <>
                                            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
                                        </>
                                    )}
                                </svg>
                            </div>
                            <h3 className="service-title">{service.title}</h3>
                            <p className="service-description">
                                {service.description}
                            </p>
                            <ul className="service-features">
                                {service.features.map(
                                    (feature, featureIndex) => (
                                        <li key={featureIndex}>{feature}</li>
                                    )
                                )}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Services;
